/**
 * Pricing boundary breakpoint DTO
 */
export class PricingBoundaryBreakpointDto {
	count?: number;
	totalGross?: number;
}
